import { BinderTab } from '@/features/Transition360/BinderTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/transition-360/projects/$projectId/assets/$projectAssetId/binder',
)({
    component: BinderTabRoute,
});

function BinderTabRoute() {
    const { projectId, projectAssetId } = Route.useParams();
    return (
        <BinderTab
            key={projectAssetId}
            projectId={projectId}
            projectAssetId={projectAssetId}
        />
    );
}
